import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './api';

export interface CurrentUser {
  id: string;
  companyId: string | null;
  email: string;
  displayName: string;
  role: 'owner' | 'admin' | 'manager' | 'member' | 'employee';
  locale: string;
  avatarUrl: string | null;
  emailVerified?: boolean;
  isStaff?: boolean;
}

export async function fetchCurrentUser(): Promise<CurrentUser | null> {
  try {
    const r = await api.get<CurrentUser>('/api/auth/me');
    return r.data;
  } catch (err: unknown) {
    const status = (err as { response?: { status?: number } })?.response?.status;
    if (status === 401 || status === 403) return null;
    throw err;
  }
}

export function useCurrentUser() {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: fetchCurrentUser,
    retry: 0,
    staleTime: 60_000,
  });
}

export function useLogout() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await api.post('/api/auth/logout');
    },
    onSuccess: () => {
      qc.removeQueries({ queryKey: ['currentUser'] });
      qc.removeQueries({ queryKey: ['company', 'me'] });
      window.location.href = '/';
    },
  });
}
